
import { defineComponent, PropType } from 'vue'

export interface RunError {
  level: number
  message?: string
  hmessage?: string
}

export default defineComponent({
  name: 'RunErrorBox',

  props: {
    errorsRendered: {
      type: Array as PropType<RunError[]>,
      default: () => []
    }
  },

  data() {
    return {
      isErrorsBlockExpanded: false
    }
  },

  computed: {
    runErrors(): Record<string, RunError[]> {
      return {
        error: this.errorsRendered.filter((error) => error.level === 0),
        warning: this.errorsRendered.filter((error) => error.level === 1),
        info: this.errorsRendered.filter((error) => error.level === 2)
      }
    }
  },

  methods: {
    getErrorTypeLabel(key: string): string {
      const map: Record<string, string> = {
        error: `${this.runErrors.error.length} Error${this.runErrors.error.length > 1 ? 's' : ''}`,
        warning: `${this.runErrors.warning.length} Warning${
          this.runErrors.warning.length > 1 ? 's' : ''
        }`,
        info: `${this.runErrors.info.length} Message${this.runErrors.info.length > 1 ? 's' : ''}`
      }
      return map[key]
    }
  }
})
